import React, { useState } from 'react';
import { Download, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ReportsDropdownProps {
  isExporting: boolean;
  isExportingEvents: boolean;
  isExportingGiftClicks: boolean;
  isExportingGetClicks: boolean;
  handleExportCSV: (filter?: 'all' | 'premium' | 'free') => void;
  handleExportUserEventsCSV: () => void;
  handleExportGiftClicksCSV: () => void;
  handleExportGetClicksCSV: () => void;
}

export const ReportsDropdown = ({
  isExporting,
  isExportingEvents,
  isExportingGiftClicks,
  isExportingGetClicks,
  handleExportCSV,
  handleExportUserEventsCSV,
  handleExportGiftClicksCSV,
  handleExportGetClicksCSV,
}: ReportsDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          className="bg-[#1E0036] hover:bg-lightPurple text-white px-5 h-10 rounded-lg flex items-center gap-2 cursor-pointer animate-none"
        >
          <Download className="h-4 w-4" />
          Reports
          <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-56 bg-white border border-[#E9E9E9] rounded-xl shadow-lg p-1 z-50">
        <DropdownMenuItem 
          onClick={() => handleExportCSV('premium')} 
          disabled={isExporting}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-violet-500/10 hover:text-[#8B5CF6] rounded-lg cursor-pointer transition-colors"
        >
          <Download className="h-4 w-4" />
          {isExporting ? 'Exporting...' : 'Premium Users '}
        </DropdownMenuItem>

        <DropdownMenuItem 
          onClick={() => handleExportCSV('free')} 
          disabled={isExporting}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-violet-500/10 hover:text-[#8B5CF6] rounded-lg cursor-pointer transition-colors"
        >
          <Download className="h-4 w-4" />
          {isExporting ? 'Exporting...' : 'Free Users '}
        </DropdownMenuItem>

        <DropdownMenuItem 
          onClick={handleExportUserEventsCSV} 
          disabled={isExportingEvents}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-violet-500/10 hover:text-[#8B5CF6] rounded-lg cursor-pointer transition-colors"
        >
          <Download className="h-4 w-4" />
          {isExportingEvents ? 'Exporting...' : 'Users Events'}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleExportGiftClicksCSV}
          disabled={isExportingGiftClicks}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-violet-500/10 hover:text-[#8B5CF6] rounded-lg cursor-pointer transition-colors"
        >
          <Download className="h-4 w-4" />
          {isExportingGiftClicks ? 'Exporting...' : 'Gift Clicks'}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleExportGetClicksCSV}
          disabled={isExportingGetClicks}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-violet-500/10 hover:text-[#8B5CF6] rounded-lg cursor-pointer transition-colors"
        >
          <Download className="h-4 w-4" />
          {isExportingGetClicks ? 'Exporting...' : 'Get Clicks'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
